export { default } from "./PauseIcon";
